import { RouteRoles } from '@/router/role-routes';
import { RouteConfig } from 'vue-router';
import { Contacts } from '@/modules/contacts/types';

const routes: RouteConfig[] = [
  {
    path: `/${Contacts.Pages.CONTACTS}`,
    name: Contacts.Pages.CONTACTS,
    component: () => import(/* webpackChunkName: "contacts" */ './views/Contacts.vue'),
    meta: {
      access_roles: RouteRoles[Contacts.Pages.CONTACTS],
    },
  },
];

export default routes;
